import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';
import { EAssignmentMode } from './common-interfaces';

import { UtilsService } from './utils.service';



@Injectable({ providedIn: 'root' })
export class PurchaseOrders_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
  ) {
  }

  public PurchaseOrders: PurchaseOrders_OperationService = this;


  isAssigned(operationName: string, mode: EAssignmentMode): Promise<boolean> {
    return this.$utils.http.post(`${environment.backendUrl}api/PurchaseOrders/operations/${operationName}/isassigned`, {mode});
  }
}
